import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RefundSectionButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

export const RefundSectionButton: React.FC<RefundSectionButtonProps> = ({ onClick, children, className }) => {
  return (
    <Button
      size="lg"
      onClick={onClick}
      className={cn("flex items-center gap-2 bg-white text-black hover:bg-gray-100 border-0", className)}
    >
      {children}
      <ArrowRight className="h-5 w-5" />
    </Button>
  );
};
